import mutations from './deviceAndRoomAssignment.mutations'
import actions from './deviceAndRoomAssignment.actions'
import getters from './deviceAndRoomAssignment.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
